import { render, staticRenderFns } from "./BulletinNotificationComponent.vue?vue&type=template&id=2b9580e4&scoped=true&"
import script from "./BulletinNotificationComponent.vue?vue&type=script&lang=js&"
export * from "./BulletinNotificationComponent.vue?vue&type=script&lang=js&"
import style0 from "./BulletinNotificationComponent.vue?vue&type=style&index=0&id=2b9580e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9580e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b9580e4')) {
      api.createRecord('2b9580e4', component.options)
    } else {
      api.reload('2b9580e4', component.options)
    }
    module.hot.accept("./BulletinNotificationComponent.vue?vue&type=template&id=2b9580e4&scoped=true&", function () {
      api.rerender('2b9580e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/bulletin/BulletinNotificationComponent.vue"
export default component.exports